import { useDispatch } from "react-redux";
import { yodaIdentityActions } from "../actions";
import { yodaIdentityConstants } from "../constants";

const identityReducer = (
  state = {
    loading: false,
    identity: {},
    customers: [],
    doors: [],
    addresses: [],
    lines: [],
    orderConfigurations: [],
    colors: [],
  },
  action,
) => {
  switch (action.type) {
    case yodaIdentityConstants.GET_ONE_REQUEST:
      return {
        ...state,
        loading: true,
        identity: {},
      };

    case yodaIdentityConstants.GET_ONE_SUCCESS:
      return {
        ...state,
        identity: action.payload.identity,
        loading: false,
      };

    case yodaIdentityConstants.GET_ONE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaIdentityConstants.GET_CUSTOMERS_REQUEST:
      return {
        ...state,
        loading: true,
        customers: [],
      };

    case yodaIdentityConstants.GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.payload.customers,
        loading: false,
      };

    case yodaIdentityConstants.GET_CUSTOMERS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaIdentityConstants.GET_DOORS_REQUEST:
      return {
        ...state,
        loading: true,
        doors: [],
      };

    case yodaIdentityConstants.GET_DOORS_SUCCESS:
      return {
        ...state,
        doors: action.payload.doors,
        loading: false,
      };

    case yodaIdentityConstants.GET_DOORS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaIdentityConstants.GET_ADDRESSES_REQUEST:
      return {
        ...state,
        loading: true,
        addresses: [],
      };

    case yodaIdentityConstants.GET_ADDRESSES_SUCCESS:
      return {
        ...state,
        addresses: action.payload.addresses,
        loading: false,
      };

    case yodaIdentityConstants.GET_ADDRESSES_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaIdentityConstants.GET_LINES_REQUEST:
      return {
        ...state,
        loading: true,
        lines: [],
      };

    case yodaIdentityConstants.GET_LINES_SUCCESS:
      return {
        ...state,
        lines: action.payload.lines,
        loading: false,
      };

    case yodaIdentityConstants.GET_LINES_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaIdentityConstants.GET_ORDER_CONFIGURATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        orderConfigurations: [],
      };

    case yodaIdentityConstants.GET_ORDER_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        orderConfigurations: action.payload.orderConfigurations,
        loading: false,
      };

    case yodaIdentityConstants.GET_ORDER_CONFIGURATIONS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaIdentityConstants.GET_COLORS_REQUEST:
      return {
        ...state,
        loading: true,
        colors: [],
      };

    case yodaIdentityConstants.GET_COLORS_SUCCESS:
      return {
        ...state,
        colors: action.payload.colors,
        loading: false,
      };

    case yodaIdentityConstants.GET_COLORS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    default:
      return state;
  }
};

export default identityReducer;
